import React, { useState, useEffect } from 'react'

import { getRequest, pathname } from '@helpers/javascript/javascript'

export const ExistingOpenDemands = ({ materialId }) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!materialId) {
      setCount(0)
      return
    }

    const path   = '/demands/fetch_existing_open'
    const params = { material: materialId }
    const url    = pathname({ path, params })
    getRequest(url).then(res => setCount(res.count)).catch(() => setCount(0))
  }, [materialId])

  if (count === 0) return null

  return (
    <div className="existing-open-demands-portal">
      <i className="fa fa-exclamation-triangle" />
      &nbsp;
      {I18n.t('workorder_demands.existing_open_demands_portal', { count })}
    </div>
  )
}
